import { render } from "./VideoAttachmentItem.vue?vue&type=template&id=2fbb457f&ts=true"
import script from "./VideoAttachmentItem.vue?vue&type=script&lang=ts"
export * from "./VideoAttachmentItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__